import { Content } from "@radix-ui/react-collapsible";
import { cx } from "@suse-o11y/class-variance";
import React from "react";

export type CollapsibleProps = React.ComponentPropsWithoutRef<typeof Content>;

export const Collapsible = React.forwardRef<React.ComponentRef<typeof Content>, CollapsibleProps>(
	({ className, style, ...props }, ref) => (
		<Content
			{...props}
			className={cx("suse-o11y/collapsible", className)}
			ref={ref}
			style={
				{
					"--content-width": "var(--radix-collapsible-content-width)",
					"--content-height": "var(--radix-collapsible-content-height)",
					...style,
				} as React.CSSProperties
			}
		/>
	),
);

Collapsible.displayName = "Collapsible";
